import { render } from "./VerifyChoices.vue?vue&type=template&id=69fd571a&scoped=true"
import script from "./VerifyChoices.vue?vue&type=script&lang=js"
export * from "./VerifyChoices.vue?vue&type=script&lang=js"

import "./VerifyChoices.vue?vue&type=style&index=0&id=69fd571a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fd571a"]])

export default __exports__